import { createSlice } from '@reduxjs/toolkit';

const fileProcessingSlice = createSlice({
  name: 'fileProcessing',
  initialState: {
    isFileProcessing: false,
    processingCount: 0,
  },
  reducers: {
    incrementProcessingCount(state) {
      state.processingCount += 1;
      state.isFileProcessing = state.processingCount > 0;
    },
    decrementProcessingCount(state) {
      state.processingCount = Math.max(state.processingCount - 1, 0);
      state.isFileProcessing = state.processingCount > 0;
    },
    resetProcessingCount(state) {
      state.processingCount = 0;
      state.isFileProcessing = false;
    },
  },
});

export function setIsFileProcessing(isFileProcessing: boolean) {
  return {
    type: 'fileProcessing/setIsFileProcessing',
    payload: { isFileProcessing }
  };
}

export const {
  incrementProcessingCount,
  decrementProcessingCount,
  resetProcessingCount,
} = fileProcessingSlice.actions;
export default fileProcessingSlice.reducer;